<div class="">
    <div class="row">
        <div class="col-sm-12">
            <button class="btn fa fa-search m-2" style="background-color:  #6e7dd2; color:#fff"
                (click)="filterToggle = !filterToggle">
                <span>&nbsp;Date Filter</span>
            </button>

            <button class="btn pull-right m-2" style="background-color:  #6e7dd2; color:#fff" (click)="exportAsExcel()">
                Download CSV
            </button>
        </div>
    </div>

    <mat-card class="filter col-lg-9 px-0 py-1" style="margin-top: 10px;" *ngIf="filterToggle">
        <mat-card-content>
            <div class="row">
                <div class="col-sm-12">
                    <button 
                        type="button" 
                        mat-raised-button 
                        class="m-1 date-filter-btn" 
                        [ngClass]="{'selected': selectedDateFilter === 'Today'}"
                        (click)="dateFilterChanged('Today')">
                        Today
                    </button>
                    <button 
                        type="button" 
                        mat-raised-button 
                        class="m-1 date-filter-btn" 
                        [ngClass]="{'selected': selectedDateFilter === 'Last7Days'}"
                        (click)="dateFilterChanged('Last7Days')">
                        Last 7 days
                    </button>
                    <button 
                        type="button" 
                        mat-raised-button 
                        class="m-1 date-filter-btn" 
                        [ngClass]="{'selected': selectedDateFilter === 'MTD'}"
                        (click)="dateFilterChanged('MTD')">
                        MTD
                    </button>
                    <button 
                        type="button" 
                        mat-raised-button 
                        class="m-1 date-filter-btn" 
                        [ngClass]="{'selected': selectedDateFilter === 'YTD'}"
                        (click)="dateFilterChanged('YTD')">
                        YTD
                    </button>
                    <button 
                        type="button" 
                        mat-raised-button 
                        class="m-1 date-filter-btn" 
                        [ngClass]="{'selected': selectedDateFilter === 'CustomDate'}"
                        (click)="CustomDate = !CustomDate">
                        Custom Date
                    </button>
                </div>                         
            </div>

            <div class="row col-sm-12 m-2 mb-3" *ngIf="CustomDate">
                <div class="col-lg-5 m-0 p-0">
                    <div class="col-sm-2 newMarginClass">
                        From:
                    </div>
                    <div class="col-sm-8">
                        <!-- <input type="text" class="form-control" placeholder="--Enter Registration--"> -->
                        <div class="input-icon right" mat-menu-item>
                            <!-- <i class="fa fa-calendar" [owlDateTimeTrigger]="dt1"></i> -->
                            <input class="form-control" placeholder="Select Date" class="form-control" id="db"
                                [(ngModel)]="fromDate" (keydown)="inputNotAllowed()" [owlDateTimeTrigger]="dt1"
                                [owlDateTime]="dt1" name="dt1" required />
                            <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
                        </div>
                    </div>
                </div>
                <div class="col-lg-5 m-0 p-0">
                    <div class="col-sm-2 newMarginClass">
                        To:
                    </div>
                    <div class="col-sm-8">
                        <!-- <input type="text" class="form-control" placeholder="--Enter Registration--"> -->
                        <div class="input-icon right" mat-menu-item>
                            <!-- <i class="fa fa-calendar" [owlDateTimeTrigger]="dt2"></i> -->
                            <input class="form-control" placeholder="Select Date" class="form-control" id="db"
                                [(ngModel)]="toDate" (keydown)="inputNotAllowed()" [owlDateTimeTrigger]="dt2"
                                [owlDateTime]="dt2" name="dt2" required />
                            <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
                        </div>
                    </div>
                </div>

                <div class="col-lg-1 p-0 m-0 ">
                    <button type="button" class="add-hover btn btn-success pull-right mr-2 fa fa-search"
                        style="background-color: #6e7dd2; color:#fff" (click)="dateFilterChanged('Dates')">
                        Search
                    </button>
                </div>
                <div class="col-lg-1 p-0 m-0">
                    <button type="button" class="btn filter-hover fa fa-eraser"
                        style="background-color: #37474f; color: #fff !important;" (click)="datefilterclear()">
                        Clear
                    </button>
                </div>
            </div>
        </mat-card-content>
    </mat-card>


    <div class="card card-body mt-2">
        <div class="row mt-2">
            <div class="col">
                <div widget class="card border-0 box-shadow">
                    <div class="card-body widget-body">
                        <div class="row form-inline">
                            <div class="form-group col-xl-1 col-sm-6 col-12" style="color: black;">Filter By:</div>
                            <div class="form-group col-xl-2 col-sm-6 col-12">
                                <mat-select placeholder="Filter by" style="width: 100%; border: 1px solid black;"
                                    onselect="reset()" placeholder="Filter by" [(ngModel)]="filterBy"
                                    class="form-control">
                                    <mat-option value="any">Any</mat-option>
                                    <mat-option value="booking">Booking Id</mat-option>
                                    <!-- <mat-option value="customer">Customer Name</mat-option> -->
                                    <mat-option value="xpcn">XPCN No</mat-option>
                                    <mat-option value="service_type">Service Type</mat-option>
                                </mat-select>

                            </div>
                            <div class="form-group col-sm-3" *ngIf="filterBy != 'asndate' && filterBy != 'xpcndate'">
                                <div class="col-sm-3  form-group " style="color: black;">
                                    Keyword:
                                </div>
                                <div class="col-sm-9 ">
                                    <input style="width: 90%; border: 1px solid black;" type="text"
                                        [(ngModel)]="keyword" class="form-control " placeholder="Search by Keyword">
                                </div>
                            </div>
                            <div class="form-group col-sm-3" *ngIf="filterBy == 'asndate' || filterBy == 'xpcndate'">
                                <div class="col-sm-3  form-group " style="color: black;">
                                    Date:
                                </div>
                                <div class="col-sm-9 ">
                                    <div class="input-icon right">
                                        <i class="fa fa-calendar" [owlDateTimeTrigger]="dt1"></i>
                                        <input type="text" [(ngModel)]="keywordDate" class="form-control"
                                            style="min-width: 150px; margin-left: 10px;" placeholder="Select Date"
                                            (keydown)="inputNotAllowed()" [owlDateTimeTrigger]="dt1" [owlDateTime]="dt1"
                                            name="dt1" />
                                        <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group col-sm-3">
                                <button class="btn fa fa-search" style="background-color:#6e7dd2; color:#fff"
                                    (click)="filter()">
                                    <span> Search</span>
                                </button>
                                <button class="btn fa fa-eraser"
                                    style="margin-left: 10px ; background-color:#37474f; color: #fff; "
                                    (click)="clear()">
                                    <span> Clear</span></button>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="col-sm-12 mt-2 p-0 ml-0 mr-0 ">
        <div class="table table-responsive tbl-fixed div1">
            <table id="example3 " class="table table-bordered text-center  p-0 m-0" matSort>

                <thead class="tbl-head m-0 p-0">


                    <tr class="tr-grid-header m-0 p-0" style="BACKGROUND: #6e7dd2;">
                        <th style="min-width: 60px;color: white;" scope="col">S No.</th>
                        <th style="color: white;min-width: 105px;" scope="col">Booking Date</th>
                        <th style="color: white;min-width: 105px;" scope="col">Scheduled Pickup Date & Time</th>
                        <th style="color: white;" scope="col">Booking ID</th>
                        <th style="color: white;" scope="col">Service Type</th>
                        <th style="color: white;min-width: 200px;" scope="col">Customer Name</th>
                        <th style="color: white;min-width: 200px;" scope="col">Customer Pick-up Location</th>
                        <th style="color: white; min-width: 200px;" scope="col">Status</th>
                        <th style="color: white; min-width: 200px;" scope="col">Executive Name & No</th>
                        <th style="color: white;" scope="col">XPCNs</th>
                        <th style="color: white;" scope="col">XPCN Status</th>
                        <th style="color: white;" scope="col">Delete XPCN</th>
                        <th style="color: white;" scope="col">Ready for Pick Up</th>
                        <th style="color: white;" scope="col">Delete Booking</th>
                    </tr>

                </thead>
                <tbody>
                    <tr *ngFor="let item of OrderList; let i=index">
                        <td>{{i+1}}</td>
                        <td>{{item.booking_date | date: "dd-MM-y"}}</td>
                        <td>{{item.FromPickUpTime | date: "dd-MM-y hh:mm aa"}}</td>
                        <td>{{item.vc_bookingid}}</td>
                        <td>{{item.ServiceType}}</td>
                        <td style="min-width: 200px;">{{item.Customer}}</td>
                        <td style="min-width: 200px;">
                            <a class="link" *ngIf="item.Latitude != null && item.Longitude != null"
                                (click)="openMap(item,item.vc_bookingid, item.PickUpAddress)">{{item.PickUpAddress}}</a>
                            <span *ngIf="item.Latitude == null || item.Longitude == null">{{item.PickUpAddress}}</span>
                        </td>
                        <td style="min-width: 200px;">{{item.Status}}</td>
                        <td style="min-width: 200px;">{{item.ExecutiveName}} ({{item.PickupExecutiveno}})</td>
                        <td>
                            <p *ngFor="let xpcn of item.XPCNDetails"><a class="link"
                                    (click)="onclickxpcn(xpcn.XPCNId)">{{xpcn.XPCNCode}}</a></p>
                           <p><a class="link" (click)="addXPCN(item.BookingId,item.canXPCNAdded)">Add</a></p>   
                        </td>
                        <td>
                            <p *ngFor="let xpcn of item.XPCNDetails">{{xpcn.isFinalised == true ? "Finalized" :
                                "Provisional"}}</p>
                        </td>
                        <td>
                            <ng-container *ngFor="let xpcn of item.XPCNDetails">
                                <button *ngIf="xpcn.XPCNId != null && xpcn.isFinalised == false"
                                    class="btn btn-danger btn-sm" (click)="deleteXPCN(xpcn.XPCNId)"
                                    style="margin-bottom: 7px;">Delete</button>
                                <button *ngIf="xpcn.XPCNId != null && xpcn.isFinalised == true"
                                    class="btn btn-secondary btn-sm"
                                    style="margin-bottom: 7px;cursor:not-allowed;">Delete</button>
                                <br>
                            </ng-container>
                        </td>
                        <td>
                            <img src="../../../assets/img/app/clipboard-check.png" *ngIf="!item.DisablePickup"
                                style="width: 25px; cursor: pointer;"
                                (click)="CloseXpcnAddButton(item.BookingId,item.ServiceType)" />

                            <img src="../../../assets/img/app/clipboard-check-disabled.png" *ngIf="item.DisablePickup"
                                style="width: 25px; cursor: not-allowed;" />

                            <!-- <button *ngIf="item.vc_xpcn != '-'" class="btn btn-success btn-sm"
                                (click)="CloseXpcnAddButton(item.BookingId)">Ready</button>
                            <button *ngIf="item.vc_xpcn == '-'"
                                class="btn btn-success btn-sm btn-disabled">Ready</button> -->
                            <!-- <p *ngIf="item.vc_xpcn != '-'" mwlConfirmationPopover [popoverTitle]="popoverTitle"
                                [popoverMessage]="popoverMessage" matTooltip="Ready For Pickup" placement="left"
                                (confirm)="CloseXpcnAddButton(item.BookingId,i)" (cancel)="cancelClicked = true"
                                [appendToBody]="true"> <i style="font-size: 24px; color: #008cff;"
                                    class="fas fa-clipboard-check"></i></p> -->
                        </td>
                        <td>
                            <button *ngIf="!item.DisableDeleteBooking" class="btn btn-danger"
                                (click)="deleteBooking(item)">Delete</button>
                            <button *ngIf="item.DisableDeleteBooking" class="btn btn-secondary"
                                style="cursor: not-allowed;">Delete</button>
                        </td>
                        <!-- <td *ngIf="user.UserType == 'Consignor'">
                            <a mat-raised-button class="btn btn-sm action_btn buttons" title="Edit XPCN"
                                style="background-color: red; color:#fff" type="button" routerLink='/xp/generate-lr'
                                [queryParams]="{ x: item.EncryptedXPCNId, y:item.EncryptedASN, z:item.VendorCode, a: 1 }"
                                data-toggle="tooltip" data-placement="top">
                                <i class="fa fa-edit" aria-hidden="true"></i>&nbsp;Edit XPCN
                            </a>
                        </td> -->
                    </tr>
                    <tr *ngIf="OrderList.length == 0">
                        <td class="text-center" colspan="100">No Records Found</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>



    <mat-paginator [length]="totalSize" [pageIndex]="currentPage" [pageSize]="pageSize"
        [pageSizeOptions]="[5, 10, 25, 50, 100]" (page)="handlePage($event)" showFirstLastButtons>
    </mat-paginator>